import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { configCategoriesTagPinEdit_template } from "../components/templates/configCategoriesTagPinEdit_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class config_categories_tag_pin_edit extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected configCategoriesTagPinEdit: configCategoriesTagPinEdit_template;

    protected getModuleName(){
        return "config_categories_tag_pin_edit";
    }

    buildContent() : Array<Element>{

        this.configCategoriesTagPinEdit = new configCategoriesTagPinEdit_template( "configCategoriesTagPinEdit", this.viewModel, this );
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Config Categories Page");

        return [ this.configCategoriesTagPinEdit.build()];
    }

    public fillPage() : void{

        this.getCategory();
    }

    protected getCategory(){

        this.configCategoriesTagPinEdit.activateLoading();

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let idCategory = this.getVnAppZone().getApp().params.idCategory;

        let usrReq_url: string = '/api/brand/' + idBrand + "/categories/get/" +idCategory;

        let usrReq_params: Array<Array<string>> = [];

        // let data = {
        //     'filter': {
        //         id: idCategory
        //     }
        // }
        //
        // usrReq_params.push(["data", ko.toJSON(data)] );

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);


        this.XHRHdl.onReadyStateFunction = this.onGetCategoryReturn;
        this.XHRHdl.execute();
    }

    protected onGetCategoryReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function() {

                let responseParsed = JSON.parse(req.request.response);


                if (responseParsed.data) {

                    obj.configCategoriesTagPinEdit.setCategory(responseParsed.data);
                    obj.getPinnedTags();
                }else {

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Category not found.");

                    let idBrand = obj.getVnAppZone().getApp().params.idBrand;
                    page('/brand/' + idBrand + '/categories');
                }
            })
        }
    }

    protected getPinnedTags(){

        this.configCategoriesTagPinEdit.activateLoading();

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let idCategory = this.getVnAppZone().getApp().params.idCategory;

        let usrReq_url: string = '/api/brand/' + idBrand + "/pinnedTagCategory/get/";

        let usrReq_params: Array<Array<string>> = [];
        //
        let data = {
            'filter': {
                idCategory: idCategory
            }
        }
        //
        usrReq_params.push(["data", ko.toJSON(data)] );

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetPinnedTagsReturn;
        this.XHRHdl.execute();
    }

    protected onGetPinnedTagsReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function() {

                let responseParsed = JSON.parse(req.request.response);

                obj.configCategoriesTagPinEdit.setPinnedTags(responseParsed.data);

                obj.configCategoriesTagPinEdit.deactivateLoading();
            })
        }
    }


    protected getTagsSuggestion(keyword, idElement) {

        let subViewModel = {pagination: {itemPerPage:25},filter: {keyword: keyword},  idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/tag/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetTagsSuggestionReturn;
        this.XHRHdl.execute();
    }


    protected onGetTagsSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function(){


                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.data.tags) {
                    let x = responseParsed.data.idElement;

                    obj.configCategoriesTagPinEdit.setFilterAutocomplete(responseParsed.data.idElement, responseParsed.data.tags);
                }

            });
        }
    }

    protected filterSimpleOnChange(idElement) {

        this.configCategoriesTagPinEdit.setPinnedTag(idElement);

    }

    public cancelForm() {
        this.cancelPinnedTags();
    }

    protected cancelPinnedTags() {

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Pinned Tags Cancelled !");

        page.redirect('/brand/' + idBrand + '/categories');
    }

    protected savePinnedTags() {

        // this.configCategoriesTagPinEdit.activateLoading();

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let idCategory = this.getVnAppZone().getApp().params.idCategory;


        let formReq_url: string = '/api/brand/' + idBrand + "/pinnedTagCategory/save/";

        let formReq_params: Array<Array<string>> = [];

        let pinnedTags = this.configCategoriesTagPinEdit.getTemplateViewModel().pinnedTags();


        let cleanPinnedTags = [];
        for (let pinnedTag of pinnedTags) {
            let tpmtagFilter = pinnedTag.tagFilter;
            pinnedTag.tagFilter = null;
            let pinnedTagx = JSON.parse(JSON.stringify(pinnedTag));
            cleanPinnedTags.push(pinnedTagx);
            pinnedTag.tagFilter = tpmtagFilter;
        }

        let subViewModel = {
            pinnedTags: cleanPinnedTags,
            idCategory: idCategory
        };

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url,formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function(req, obj){

            return function() {

                obj.manageResponse(req, obj, function(){
                    let responseParsed = JSON.parse(req.request.response);

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Pinned Tags saved successfully !");
                    obj.getVnAppZone().showNotificationToModule();

                    obj.configCategoriesTagPinEdit.deactivateLoading();

                })
            }
        });
        XHRHdl.execute();
    }
}



// WEBPACK FOOTER //
// ./js/modules/config_categories_tag_pin_edit.ts